export default {
    PtSelectMenu: {
        deselect: '取消全部勾选',
        selected: '条已勾选',
    },
};
